module.exports = __webpack_public_path__ + "thumbnail-b3be3c2f32d65293cc043da499ce072b.png";